import { Box, Icon } from "@shopify/polaris";
import { React, useEffect, useState } from "react";
import intl from "../../../../i18n/intl";
import { ChevronRightMinor , ChevronDownMinor } from "@shopify/polaris-icons";
const CateTab = ({
  data,
  show,
  onShow,
  // CateValue,
  handleCategory,
  handleCategoryVal,
}) => {
  const [activeData, setActiveData] = useState({
    active: "",
    currentActive: "", //一级分类
    selectCurrent1: -2,
    active2: "",
    currentActive2: "", //二级分类
    active3: "",
    currentActive3: "", //三级分类
    cateClass: "",
  });
  const handleCateSelect = (first, sencond = "", third = "", e, id, title) => {
    e.stopPropagation();
    handleCategory(id, title);
    // currentActiveFn(id)
    setActiveData((prevValue) => ({
      ...prevValue,
      active: "",
      currentActive: "", //一级分类
      selectCurrent1: -2,
      active2: "",
      currentActive2: "", //二级分类
      active3: "",
      currentActive3: "", //三级分类
    }));
    onShow();
  };
 
  useEffect(() => {
    let isMount = true;
    // 监听屏幕变化 控制日历方向
    var popup = document.querySelector('.cate_calss_ListFilledMajor');
    function handleBodyClick(event) {
      // 检查点击事件是否发生在弹窗之外
      if ( show && event.target !== popup && !popup.contains(event.target)) {
        // 关闭弹窗的逻辑
        setActiveData((prevValue) => ({
          ...prevValue,
          active: "",
          currentActive: "", //一级分类
          selectCurrent1: -2,
          active2: "",
          currentActive2: "", //二级分类
          active3: "",
          currentActive3: "", //三级分类
        }));
        onShow();
      }
    }
    if (isMount && show) {
      
      // 每次打开清空状态
      window.addEventListener("click", handleBodyClick);
      setActiveData((prevValue) => ({
        ...prevValue,
        active: "",
        currentActive: "", //一级分类
        selectCurrent1: -2,
        active2: "",
        currentActive2: "", //二级分类
        active3: "",
        currentActive3: "", //三级分类
      }));
    }
    return () => {
      isMount = false;
      window.removeEventListener("click", handleBodyClick);
    };
    // eslint-disable-next-line
  }, [show]);
  // useEffect(() => {
  //   let isMount = false;
  //   if (!isMount) {
  //     currentActiveFn(CateValue);
  //   }
  //   return () => {
  //     isMount = true;
  //   };
  //   // eslint-disable-next-line
  // }, [CateValue]);
  // const currentActiveFn = () => {
  //   for (let i = 0; i < data.length; i++) {
  //     if (data[i].category_id === CateValue) {
  //       handleCategoryVal(
  //         data[i].category_id,
  //         data[i].category_name,
  //         "",
  //         "",
  //         "",
  //         ""
  //       );
  //     }
  //     for (let j = 0; j < data[i].children.length; j++) {
  //       if (data[i].children[j].category_id === CateValue) {
  //         handleCategoryVal(
  //           data[i].category_id,
  //           data[i].category_name,
  //           data[i].children[j].category_id,
  //           data[i].children[j].category_name,
  //           "",
  //           ""
  //         );
  //       }
  //       for (let k = 0; k < data[i].children[j].children.length; k++) {
  //         if (data[i].children[j].children[k].category_id === CateValue) {
  //           handleCategoryVal(
  //             data[i].category_id,
  //             data[i].category_name,
  //             data[i].children[j].category_id,
  //             data[i].children[j].category_name,
  //             data[i].children[j].children[k].category_id,
  //             data[i].children[j].children[k].category_name
  //           );
  //         }
  //       }
  //     }
  //   }
  // };
  return (
    <Box
      className={`find-product-cate ${
        activeData.cateClass
      } find-product-cate_mob ${show ? "find-product-cate-show" : ""} ${
        activeData.active !== "" ? "radius_active" : ""
      }`}
      // onMouseLeave={(e) => {
      //   e.stopPropagation();
      //   setActiveData((prevValue) => ({
      //     ...prevValue,
      //     active: "",
      //     currentActive: "", //一级分类
      //     selectCurrent1: -2,
      //     active2: "",
      //     currentActive2: "", //二级分类
      //     active3: "",
      //     currentActive3: "", //三级分类
      //   }));
      //   onShow();
      // }}
    >
      {/* <Box className="find-product-close" onClick={()=>onShow()}>
            <Icon
                source={CancelMajor}
                tone="base"
            />
            </Box> */}
      <Box className="find-product-content find-product-content_pc">
        <ul className="find-product-content-left">
          <Box
            className={`find-product-content-left-first  ${
              activeData.selectCurrent1 === -1 ? "cate-current_active" : ""
            }`}
            onClick={(e) => {
              e.stopPropagation();
              handleCateSelect(-1, "", "", e, "", "All Categories")
              handleCategoryVal('','All Categories',"","","","")
            }
            }
            onMouseEnter={() => {
              setActiveData((prevValue) => ({
                ...prevValue,
                active: "",
                active2: "",
                selectCurrent1: -1,
              }));
            }}
            onMouseLeave={() => {
              setActiveData((prevValue) => ({
                ...prevValue,
                active: "",
                active2: "",
                selectCurrent1: -1,
              }));
            }}
          >
            <Box className="first-top-left">
              <p className="cateName">{intl.get("All Categories")}</p>
            </Box>
          </Box>
          {data?.length > 0 && data.map((item, ind) => (
            <li
              key={ind}
              
              className={`find-product-content-left-first ${
                activeData.selectCurrent1 === ind ? "cate-current_active" : ""
              }`}
              onMouseEnter={() => {
                
                setActiveData((prevValue) => ({
                  ...prevValue,
                  active: ind,
                  active2: "",
                  selectCurrent1: ind,
                }));
              }}
              onMouseLeave={() => {
                setActiveData((prevValue) => ({
                  ...prevValue,
                  active: ind,
                  active2: "",
                }));
              }}
            >
              <Box className="first-top-left">
                {/* <span className='cateImg' style={{backgroundImage:'url(/new-product/category.png)',backgroundPosition:`${ind > 7 ? -48 * (ind -7 ) : (-48 * ind)}px ${ind > 7 ? -48 : 0}px`}}></span> */}
                <p className="cateName" onClick={(e) => {
                e.stopPropagation();
                handleCategoryVal(item.category_id,item.category_name,"","","","")
                handleCateSelect(
                  ind,
                  "",
                  "",
                  e,
                  item.category_id,
                  item.category_name
                )
              }}>{item.category_name}</p>
              </Box>
              <Box
                className={`find-product-content-right ${
                  activeData.active === ind ? "cate-item" : ""
                } ${activeData.active2 !== "" ? "radius_active4" : ""} ${
                  activeData.active === ind ? "radius_active2" : ""
                }`}
              >
                <ul className="find-product-content-right-cate1">
                  {item.children.map((it, key) => (
                    <li
                      key={key}
                      className={`find-product-content-right-first `}
                      onMouseEnter={() => {
                        setActiveData((prevValue) => ({
                          ...prevValue,
                          active2: key,
                        }));
                      }}
                      onMouseLeave={() => {
                        setActiveData((prevValue) => ({
                          ...prevValue,
                          active2: key,
                        }));
                      }}
                      
                    >
                      <p
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCategoryVal(item.category_id,item.category_name,it.category_id,
                          it.category_name,"","")
                        handleCateSelect(
                          ind,
                          key,
                          "",
                          e,
                          it.category_id,
                          it.category_name
                        )
                       } }
                        className={`${
                          activeData.active2 === key ? "show_cate1" : ""
                        }`}
                      >
                        {it.category_name}
                      </p>
                      <Box
                        className={`find-product-content-right-child ${
                          activeData.active2 === key ? "cate2-item-child" : ""
                        } ${
                          activeData.active2 === key ? "radius_active3" : ""
                        }`}
                      >
                        <ul className="find-product-content-right-cate2">
                          {it.children.map((child, cl) => (
                            <li
                              key={cl}
                              onClick={(e) => {
                                handleCategoryVal(item.category_id,item.category_name,it.category_id,
                                  it.category_name,child.category_id,
                                  child.category_name)
                                handleCateSelect(
                                  ind,
                                  key,
                                  cl,
                                  e,
                                  child.category_id,
                                  child.category_name
                                )
                              }}
                            >
                              <p className={``}>{child.category_name}</p>
                            </li>
                          ))}
                        </ul>
                      </Box>
                    </li>
                  ))}
                </ul>
              </Box>
            </li>
          ))}
        </ul>
      </Box>
      <Box className="find-product-content find-product-content_mob">
        <ul className="find-product-content-left">
          <Box
            className={`find-product-content-left-first  ${
              activeData.selectCurrent1 === -1 ? "cate-current_active" : ""
            }`}
            onClick={(e) => {
              handleCategoryVal('','All Categories',"","","","")
              handleCateSelect(-1, "", "", e, "", "All Categories")
            }
            }
          >
            <Box className="first-top-left">
              <p className="cateName">{intl.get("All Categories")}</p>
            </Box>
          </Box>
          {data?.length > 0 && data.map((item, ind) => (
            <li
              key={ind}
              className={`find-product-content-left-first ${
                activeData.selectCurrent1 === ind ? "cate-current_active" : ""
              }`}
            >
              <Box className="first-top-left">
                {/* <span className='cateImg' style={{backgroundImage:'url(/new-product/category.png)',backgroundPosition:`${ind > 7 ? -48 * (ind -7 ) : (-48 * ind)}px ${ind > 7 ? -48 : 0}px`}}></span> */}
                <p
                  className="cateName"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCategoryVal(item.category_id,item.category_name,"","","","")
                    handleCateSelect(
                      ind,
                      "",
                      "",
                      e,
                      item.category_id,
                      item.category_name
                    );
                  }}
                >
                  {item.category_name}
                </p>
                <p
                  className="cateName_right"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveData((prevValue) => ({
                      ...prevValue,
                      active: ind,
                      active2: "",
                      selectCurrent1: ind,
                    }));
                  }}
                >
                  <Icon source={ChevronRightMinor} tone="base" />
                </p>
              </Box>
              <Box
                className={`find-product-content-right ${
                  activeData.active === ind ? "cate-item" : ""
                } ${activeData.active2 !== "" ? "radius_active4" : ""} ${
                  activeData.active === ind ? "radius_active2" : ""
                }`}
              >
                <ul className="find-product-content-right-cate1">
                  {item.children.map((it, key) => (
                    <li
                      key={key}
                      className={`find-product-content-right-first ${
                        activeData.active2 === key ? "show_cate1" : ""
                      }`}
                    >
                    <Box className="second-top-left">
                      <p
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCategoryVal(item.category_id,item.category_name,it.category_id,
                            it.category_name,"","")
                          handleCateSelect(
                            ind,
                            key,
                            "",
                            e,
                            it.category_id,
                            it.category_name
                          );
                        }}
                      >
                        {it.category_name}
                      </p>
                      <p
                        className="cateName_right"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveData((prevValue) => ({
                            ...prevValue,
                            active2: key,
                          }));
                        }}
                      >
                        <Icon source={activeData.active2 === key ? ChevronDownMinor : ChevronRightMinor } tone="base" />
                      </p>
                      </Box>
                      <Box
                        className={`find-product-content-right-child ${
                          activeData.active2 === key ? "cate2-item-child" : ""
                        } ${
                          activeData.active2 === key ? "radius_active3" : ""
                        }`}
                      >
                        <ul className="find-product-content-right-cate2">
                          {it.children.map((child, cl) => (
                            <li
                              key={cl}
                              onClick={(e) => {
                                e.stopPropagation()
                                handleCategoryVal(item.category_id,item.category_name,it.category_id,
                                  it.category_name,child.category_id,
                                  child.category_name)
                                handleCateSelect(
                                  ind,
                                  key,
                                  cl,
                                  e,
                                  child.category_id,
                                  child.category_name
                                )
                              }
                            }
                            >
                              <p className={``}>{child.category_name}</p>
                            </li>
                          ))}
                        </ul>
                      </Box>
                    </li>
                  ))}
                </ul>
              </Box>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
};

export default CateTab;
